define('app-blazy/module',["blazy"], function (Blazy) {
    return {
        loadLazy: function () {
            var bLazy = new Blazy({
                offset: 400, // Loads images 400px before they're visible
                selector: ('.b-lazy, .b-lazy-div'),
                breakpoints: [
                    {
                        width: 360, // max-width
                        src: 'data-src-mobile'
                    },
                    {
                        width: 480,// max-width
                        src: 'data-src-small'
                    },
                    {
                        width: 768, // max-width
                        src: 'data-src-medium'
                    }
                ]
            });
        },
        loadLazyDialog: function () {
            var bLazy = new Blazy({
                offset: 4000
            });
        }
    }
});
